import { LogModel } from '../../core/models';
import { MAX_ACCEPTABLE_RPM } from '../consts/max-acceptable-rpm';

const HARD_BRAKING_EVENT_IDS = ['6007', '07'];
const ACCELERATION_EVENT_IDS = ['6006', '06'];
const IRIDIUM_EVENT_IDS = ['8001'];

export function isSpeedingIncident(log: LogModel) {
  if (!log.maxSpeed || log.maxSpeed === '0' || !log.speed || log.speed === '0') {
    return false;
  }

  return Number(log.speed) > Number(log.maxSpeed);
}

export function isAccelerationIncident(log: LogModel) {
  return ACCELERATION_EVENT_IDS.includes(log.logEventid);
}

export function isIridiumIncident(log: LogModel) {
  return IRIDIUM_EVENT_IDS.includes(log.logEventid);
}

export function isHardBrakingIncident(log: LogModel) {
  return HARD_BRAKING_EVENT_IDS.includes(log.logEventid);
}

export function isOverRPMIncident(log: LogModel) {
  return log.logRpm > MAX_ACCEPTABLE_RPM;
}
